import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Status = "good" | "bad" | "unknown" | null | undefined;

interface PhoneStatusIconProps {
  status: Status;
  lastSmsTime?: string | null;
  phoneType?: string | null;
  phone?: string | null;
  manual?: boolean;
}

function fmt(ts?: string | null): string {
  if (!ts) return "never";
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return ts;
  return d.toLocaleString();
}

export function PhoneStatusIcon({
  status,
  lastSmsTime,
  phoneType,
  phone,
  manual,
}: PhoneStatusIconProps) {
  const s: Status = status ?? "unknown";
  const Icon = s === "good" ? CheckCircle2 : s === "bad" ? XCircle : HelpCircle;
  const color =
    s === "good"
      ? "text-green-500"
      : s === "bad"
        ? "text-red-500"
        : "text-muted-foreground";

  const synced = s === "good" || s === "bad";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center gap-0.5">
          <Icon className={cn("h-4 w-4", color)} />
          {synced ? (
            <span className="text-[9px] leading-none text-muted-foreground/60">
              ↑R
            </span>
          ) : null}
        </span>
      </TooltipTrigger>
      <TooltipContent className="space-y-0.5">
        <div className="font-medium uppercase">
          {s}
          {manual ? " (manual)" : ""}
        </div>
        {phone ? <div className="font-mono">{phone}</div> : null}
        <div>Last SMS: {fmt(lastSmsTime)}</div>
        <div>Type: {phoneType || "—"}</div>
        {synced ? (
          <div className="text-muted-foreground">↑ Synced to Reach</div>
        ) : null}
      </TooltipContent>
    </Tooltip>
  );
}
